<template>
  <div id="">
    <div class="emd-stripe">
      <div class="emd-bounds">
        <div class="emd-section fade-in">
          <div v-if="isLoading && !requestFailed" class="emd-box _state_loading"></div>
          <p v-else-if="!isLoading && requestFailed" class="emd-text _color_danger _align_center">{{$t('edit.error')}}</p>
          <div v-else class="emd-box fade-in">
            <EmdBoxHeader :title="$t('breadcrumb.edit.images')">
              <button class="emd-btn _color_secondary _type_text" @click="disabled = !disabled">{{$t('edit.edit')}}</button>
            </EmdBoxHeader>
            <div class="emd-box__content">
              <div class="emd-alert _color_success hideFeedback" ref="feedback">
                <p>{{$t('edit.form.images.success_message')}}</p>
              </div>
              <error-list :items="errors"></error-list>
              <div class="emd-section">
                <label class="emd-label">{{$t('edit.form.images.preview')}}</label>
                <div class="emd-flex">
                  <div class="emd-flex-item _basis_12 _basis_3_md">
                    <div class="emd-chunk">
                      <div class="emd-image-color jsColorVisualizer" :style="`background-color: ${backgroundColor}`">
                        <img :src="avatarLink" alt="Logo">
                      </div>
                    </div>
                  </div>
                  <div class="emd-flex-item _shrink">
                    <div class="emd-chunk">
                      <input @focus="sendFsEvent('imagem-avatar')" class="emd-btn _color_secondary" :disabled="disabled" type="file" @change="uploadAvatar">
                    </div>
                    <div class="emd-form-group">
                      <label class="emd-label">{{$t('edit.form.images.color')}}</label>
                      <input class="emd-input color-selector jsColorSelector" type="color" v-model="backgroundColor" :disabled="disabled">
                    </div>
                  </div>
                </div>
              </div>
              <div class="emd-section">
                <label class="emd-label">{{$t('edit.form.images.app')}}</label>
                <div class="emd-flex">
                  <div class="emd-flex-item _basis_12 _basis_6_md">
                    <div class="emd-image-item">
                      <div class="emd-banner-placeholder" v-if="banners.length === 0">
                        <img :src="defaultIcon">
                      </div>
                      <carousel v-if="banners.length > 0" :images="bannersLink" :disabled="disabled || denyRemoveBanner" v-on:deleteImage="excludeImage"></carousel>
                    </div>
                  </div>
                  <div class="emd-flex-item _basis_12 _basis_6_md">
                    <div class="emd-chunk">
                      <input @focus="sendFsEvent('imagem-banner')" class="emd-btn _color_secondary" :disabled="disabled || allowAddBanner" type="file" @change="uploadBanner">
                    </div>
                    <div class="emd-chunk">
                      <div class="emd-image-thumb" v-for="(banner, index) in bannersLink" :key="index">
                        <img :src="banner" alt="">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="emd-flex _justify_flex-end" v-show="!disabled">
                <div class="emd-flex-item _shrink">
                  <button class="emd-btn _color_primary _type_text" type="button" @click="disabled = !disabled">{{$t('edit.cancel')}}</button>
                </div>
                <div class="emd-flex-item _shrink">
                  <button class="emd-btn _color_secondary" type="button" @click="saveImages">{{$t('edit.save')}}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Carousel from '@/components/project/Carousel.vue'
import ErrorList from '@/components/project/ErrorList.vue'
import DefaultIcon from '@/assets/default-icon.png'
import EmdBoxHeader from '@/components/emerald/EmdBoxHeader'
import sendFsCustomEvent from '@/mixins/sendFsCustomEvent'

export default {
  name: 'ApplicationImages',
  components: {
    Carousel,
    ErrorList,
    EmdBoxHeader
  },
  mixins: [sendFsCustomEvent],
  computed: {
    isLoading () {
      return this.$store.state.application.detail.isLoading
    },
    requestFailed () {
      return this.$store.state.application.detail.requestFailed
    },
    backgroundColor: {
      get () {
        if (this.body.color === undefined) {
          this.body.color = this.$store.state.application.detail.color
        }
        return this.body.color
      },
      set (value) {
        this.body.color = value
      }
    },
    avatar: {
      get () {
        if (this.body.avatar === undefined) {
          this.body.avatar = this.$store.state.application.detail.avatar
        }
        return this.body.avatar
      },
      set (value) {
        this.body.avatar = value
      }
    },
    banners () {
      if (this.body.banners === undefined) {
        this.body.banners = this.$store.state.application.detail.banners
      }
      return this.body.banners
    },
    bannersLink () {
      return this.$store.getters.getBannersImageLink(this.banners)
    },
    avatarLink () {
      if (this.avatar) {
        return this.$store.getters.getAvatarImageLink(this.avatar)
      }
      return DefaultIcon
    },
    defaultIcon () {
      return DefaultIcon
    },
    allowAddBanner () {
      return this.banners.length >= 5
    },
    denyRemoveBanner () {
      return this.banners.length < 1
    }
  },
  data () {
    return {
      disabled: true,
      errors: [],
      body: {
        color: undefined,
        avatar: undefined,
        banners: undefined
      }
    }
  },
  methods: {
    displayFeedback () {
      this.$refs.feedback.classList.add('displayFeedback')
      this.$refs.feedback.classList.remove('hideFeedback')
      setTimeout(() => {
        this.$refs.feedback.classList.remove('displayFeedback')
        this.$refs.feedback.classList.add('hideFeedback')
      }, 2000)
    },
    excludeImage (index) {
      this.body.banners.splice(index, 1)
    },
    saveImages (e) {
      const element = e.target
      element.classList.add('_state_loading')
      this.$store.dispatch('UPDATE_IMAGES', this.body)
        .then(response => {
          element.classList.remove('_state_loading')
          this.disabled = true
          this.errors = []
          this.displayFeedback()
        })
        .catch(() => {
          element.classList.remove('_state_loading')
        })
    },
    uploadAvatar (e) {
      const element = e.target
      const files = e.target.files
      if (files.length > 0) {
        element.classList.add('_state_loading')
        this.$store.dispatch('UPLOAD_AVATAR', files[0])
          .then(response => {
            element.classList.remove('_state_loading')
            this.errors = []
            this.avatar = response.image_id
          })
          .catch(response => {
            element.classList.remove('_state_loading')
            if (response.status === 400) {
              this.errors = response.body.errors
            }
          })
      }
    },
    uploadBanner (e) {
      const element = e.target
      const files = e.target.files
      if (files.length > 0) {
        element.classList.add('_state_loading')
        this.$store.dispatch('UPLOAD_BANNER', files[0])
          .then(response => {
            element.classList.remove('_state_loading')
            element.value = ''
            this.errors = []
            this.body.banners.push(response.image_id)
          })
          .catch(response => {
            element.classList.remove('_state_loading')
            element.value = ''
            if (response.status === 400) {
              this.errors = response.body.errors
            }
          })
      }
    }
  }
}
</script>
<style scoped>
 .emd-image-color {
  width: 100%;
  height: 155px;
  border-radius: 4px;
  background-color: #fff;
  display: flex;
  align-items: center;
}
.color-selector {
  padding: 0;
  height: 42px;
}
.emd-image-color img {
  display: block;
  margin: 0 auto;
  width: 92px;
  height: auto;
}
.emd-image-thumb {
  display: block;
  margin: 2px 0px;
  width: 144px;
  height: auto;
}
.emd-banner-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 597px;
  height: 325px;
}
.emd-banner-placeholder img {
  margin: 0 auto;
  height: auto;
  width: 92px;
}
.emd-box._state_loading {
  height: 709px;
  background-repeat: no-repeat;
  background-image:
    linear-gradient(#f4f4f4),
    linear-gradient(#f4f4f4),
    linear-gradient(#f4f4f4),
    linear-gradient(#f4f4f4),
    linear-gradient(#f4f4f4);
  background-size:
    115px 25px,
    150px 20px,
    98% 155px,
    98% 320px,
    185px 20px;
  background-position:
    1.59% 3.75%,
    1.59% 16.15%,
    35.75% 25%,
    35.75% 93.25%,
    1.59% 48.5%;
  opacity: 1;
  animation: opacity 1s infinite ease-in;
  transition: opacity 1s;
}
@media (min-width:768px) {
  .emd-box._state_loading {
    background-image:
      linear-gradient(#f4f4f4),
      linear-gradient(#f4f4f4),
      linear-gradient(#f4f4f4),
      linear-gradient(#f4f4f4),
      linear-gradient(#f4f4f4);
    background-size:
      115px 25px,
      150px 20px,
      23.35% 155px,
      48% 320px,
      185px 20px;
    background-position:
      1.59% 3.75%,
      1.59% 16.15%,
      1.75% 25%,
      2.45% 93.25%,
      1.59% 48.5%;
  }
}

</style>
